import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import {
  Paper, FormControl, TextField, Button, InputLabel, Select, MenuItem,
} from '@material-ui/core';
import { callTypeEditValidationSchema } from '../utils/util';
import Actions from '../actions';

class CallTypeEditForm extends Component {
    // eslint-disable-next-line react/state-in-constructor
    state={
      name: '',
      title: '',
      description: '',
      maxParticipants: 1,
      platform: '',
      img: '',
      shareText: '',
      shareImg: '',
      groupCallImageUrl: '',
      upcomingCallImageUrl: '',
      isTherapistCall: false,
    };

    componentDidMount() {
      const { data } = this.props;
      this.setState({
        name: data.name,
        title: data.title,
        description: data.description,
        maxParticipants: data.maxParticipants,
        platform: data.platform,
        img: data.img,
        shareText: data.shareText,
        shareImg: data.shareImg,
        groupCallImageUrl: data.groupCallImageUrl,
        upcomingCallImageUrl: data.upcomingCallImageUrl,
        isTherapistCall: data.isTherapistCall || false,
      });
      this.changed = new Set();
    }

    formupdated = (e) => {
      e.preventDefault();
      // eslint-disable-next-line react/no-access-state-in-setstate
      this.setState({ ...this.state, [e.target.name]: e.target.value });
      this.changed.add(e.target.name);
    }

    formSubmitted = (e) => {
      e.preventDefault();
      const data = { _id: this.props.data._id };
      this.changed.forEach((updatedData) => {
        // eslint-disable-next-line no-return-assign
        return (
          data[updatedData] = this.state[updatedData]
        );
      });
      // alert(JSON.stringify(data));
      callTypeEditValidationSchema.validate(data)
        .then(() => {
          return this.props.editCallType(data)
            .then(() => {
              alert(`Call Type Updated Successfully!! \n Data: ${JSON.stringify(data)}`);
              this.props.cancel();
            });
        })
        .catch((err) => { return alert(err); });
    }

    render() {
      return (
        <Paper style={{ width: '500px', padding: '50px', marginTop: 20 }}>
          <h3 style={{ marginTop: 0 }}>Call Type Form</h3>
          <form className="form" onSubmit={this.formSubmitted} autoComplete="off">
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="name" name="name" label="Name" value={this.state.name} onChange={(e) => { this.formupdated(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="title" name="title" label="Title" value={this.state.title} onChange={(e) => { this.formupdated(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField
                id="description"
                name="description"
                label="Description"
                value={this.state.description}
                onChange={(e) => { this.formupdated(e); }}
              />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField type="url" id="img" name="img" label="Image Url" value={this.state.img} onChange={(e) => { this.formupdated(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="shareText" name="shareText" label="Share Text" value={this.state.shareText} onChange={(e) => { this.formupdated(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField id="shareImg" name="shareImg" label="Share Image" value={this.state.shareImg} onChange={(e) => { this.formupdated(e); }} />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField
                id="groupCallImageUrl"
                name="groupCallImageUrl"
                label="Group Call Image Url"
                value={this.state.groupCallImageUrl}
                onChange={(e) => { this.formupdated(e); }}
              />
            </FormControl>
            <FormControl fullWidth style={{ marginTop: '15px' }}>
              <TextField
                id="upcomingCallImageUrl"
                name="upcomingCallImageUrl"
                label="Upcoming Call Image Url"
                value={this.state.upcomingCallImageUrl}
                onChange={(e) => { this.formupdated(e); }}
              />
            </FormControl>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
              <FormControl style={{ marginTop: '15px', width: 150 }}>
                <TextField
                  type="number"
                  id="maxParticipants"
                  name="maxParticipants"
                  label="Max. Participants"
                  value={this.state.maxParticipants}
                  onChange={(e) => { this.formupdated(e); }}
                />
              </FormControl>
              <FormControl style={{ marginTop: '15px', width: 150 }}>
                <InputLabel id="simple-select-platform-label">Platform</InputLabel>
                <Select
                  labelId="simple-select-platform-label"
                  id="simple-select-platform"
                  value={this.state.platform}
                  name="platform"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value="mobile">
                    Mobile
                  </MenuItem>
                  <MenuItem value="web">
                    Web
                  </MenuItem>
                </Select>
              </FormControl>
              <FormControl style={{ marginTop: '15px', width: 150 }}>
                <InputLabel id="simple-select-platform-label">Is therapist call?</InputLabel>
                <Select
                  labelId="simple-select-platform-label"
                  id="simple-select-platform"
                  value={this.state.isTherapistCall}
                  name="isTherapistCall"
                  onChange={(e) => { return this.formupdated(e); }}
                  style={{ textAlign: 'left' }}
                >
                  <MenuItem value>
                    Yes
                  </MenuItem>
                  <MenuItem value={false}>
                    No
                  </MenuItem>
                </Select>
              </FormControl>
            </div>
            <FormControl>
              <div style={{
                width: 400, display: 'flex', justifyContent: 'space-between', marginTop: 20,
              }}
              >
                <Button variant="contained" color="secondary" onClick={() => { return this.props.cancel(); }}>Cancel</Button>
                <Button variant="contained" type="submit" color="primary">Confirm</Button>
              </div>
            </FormControl>
          </form>
        </Paper>
      );
    }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch);
}

export default withRouter(connect(() => { return {}; }, mapDispatchToProps)(CallTypeEditForm));
